export default __webpack_public_path__ + "static/case-1-21c36822bd90639c28a57fc02b5fdd1e.webp";